import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM11.984 20H12V4C7.58172 3.99558 3.99642 7.57372 3.992 11.992C3.98758 16.4103 7.56572 19.9956 11.984 20Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "PieChart50"
);
